"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DashboardController_js_1 = require("./DashboardController.js");
exports.DashboardController = DashboardController_js_1.DashboardController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/controllers/index.ts
// module id = 344
// module chunks = 0